<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <h2 class="text-eveer">Sports List</h2>
      <base-button
        v-if="role == 'Admin'"
        type="primary"
        round
        icon
        class="top-button"
        @click="$router.push('add?id=-1')"
      >
        <i class="fa fa-plus"></i>
      </base-button>
    </div>

    <div class="row mt-2">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">Sports List</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                  type="search"
                  class="mb-3 search-input"
                  clearable
                  prefix-icon="el-icon-search"
                  placeholder="Search sports"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>

            <el-table :data="queriedData" style="font-size: 13px">
              <el-table-column :min-width="150" align="left" label="Image">
                <div slot-scope="props">
                  <img
                    class="sport-img"
                    :src="getSportImage(props.row)"
                    alt="Sport"
                  />
                </div>
              </el-table-column>

              <el-table-column :min-width="220" align="left" label="Sport Name">
                <div slot-scope="props">
                  <div style="color: #ba54f5; font-weight: 300">
                    {{ props.row.game_name }}
                  </div>
                </div>
              </el-table-column>

              <el-table-column :min-width="120" align="right" label="Control">
                <div slot-scope="props">
                  <i
                    v-if="role == 'Admin' && props.row._id"
                    class="fa fa-edit text-warning icon-padding"
                    @click="$router.push('edit?id=' + props.row._id)"
                    title="Edit Sport"
                    style="cursor: pointer"
                  >
                  </i>
                  <i
                    v-if="role == 'Admin' && props.row._id"
                    class="fa fa-trash text-danger icon-padding"
                    @click="deleteSport(props.row)"
                    title="Delete Sport"
                    style="cursor: pointer"
                  >
                  </i>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div>
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <div class="row loader-pos">
      <div class="sk-chase" v-if="loading">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>

      <div class="no-data-message" v-if="noDataMessage">
        <div>There are no records found</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    queriedData() {
      let result = this.searchQuery ? this.searchedData : this.tableData;
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchQuery ? this.searchedData.length : this.tableData.length;
    },
  },
  data() {
    return {
      role: window.localStorage.getItem("role"),
      noDataMessage: false,
      loading: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 50, 100, 1000],
        total: 0,
      },
      searchQuery: "",
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  async mounted() {
    await this.fetchSports();
  },
  watch: {
    searchQuery(value) {
      if (!value) {
        this.searchedData = [];
        return;
      }

      const result = this.fuseSearch
        ? this.fuseSearch.search(value).map((item) => item.item)
        : [];
      this.searchedData = result;
      this.pagination.currentPage = 1;
    },
  },
  methods: {
    async fetchSports() {
      this.loading = true;
      this.noDataMessage = false;

      try {
        const response = await this.$apiService.getCall(
          "event/admin/games"
        );
        const sports =
          (response.apidata && (response.apidata.Data || response.apidata.games)) ||
          [];

        this.tableData = sports.slice().sort((a, b) => {
          return new Date(b.created_at || 0) - new Date(a.created_at || 0);
        });
        this.fuseSearch = new Fuse(this.tableData, {
          keys: ["game_name"],
          threshold: 0.3,
        });
        this.noDataMessage = this.tableData.length === 0;
      } finally {
        this.loading = false;
      }
    },
    getSportImage(sport) {
      return (
        sport.image_url ||
        sport.imageUrl ||
        sport.image ||
        "img/image_placeholder.jpg"
      );
    },
    async deleteSport(sport) {
      const sportId = sport && sport._id;
      if (!sportId) {
        this.$apiService.notify("Sport id is missing.");
        return;
      }

      const confirmed = confirm(
        `Are you sure you want to delete ${sport.game_name || "this sport"}?`
      );

      if (!confirmed) {
        return;
      }

      this.loading = true;

      try {
        const response = await this.$apiService.deleteCall(
          `event/delete-game/${sportId}`
        );
        const message =
          (response.error &&
            response.error.response &&
            response.error.response.data &&
            response.error.response.data.Message) ||
          (response.apidata && response.apidata.Message) ||
          "Unable to delete sport.";

        if (
          response.isError ||
          (response.apidata &&
            response.apidata.Message &&
            response.apidata.Message !== "Success")
        ) {
          this.$apiService.notify(message);
          return;
        }

        this.$apiService.notify("Sport has been deleted.");
        await this.fetchSports();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.pagination-select,
.search-input {
  width: 200px;
}

.sport-img {
  height: 70px;
  object-fit: cover;
  border-radius: 4px;
}
</style>
